import { useEffect } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WaitlistTable from "./WaitlistTable";

const SKELETON_ROWS = 6;

const LoadingSkeleton = () => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
      <Skeleton
        key={i}
        variant="rectangular"
        height={44}
        sx={{ borderRadius: "var(--radius-md)" }}
      />
    ))}
  </Box>
);

const EmptyState = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "var(--space-sm)",
      padding: "var(--space-xl)",
      color: "var(--text-color-gray)",
    }}
  >
    <PersonOutlineOutlinedIcon sx={{ fontSize: 48, opacity: 0.3 }} />
    <Typography sx={{ fontSize: "var(--text-sm)", fontWeight: 500 }}>
      No one on the waitlist yet.
    </Typography>
    <Typography sx={{ fontSize: "var(--text-xs)", opacity: 0.7 }}>
      Signups will appear here in real time once the waitlist is active.
    </Typography>
  </Box>
);

const Waitlist = ({ list, loading, subscribeWaitlist }) => {
  useEffect(() => {
    const unsubscribe = subscribeWaitlist();
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [subscribeWaitlist]);

  return (
    <Box sx={{ flex: 1, overflowY: "auto", padding: "var(--space-lg)" }}>
      {loading ? (
        <LoadingSkeleton />
      ) : list.length === 0 ? (
        <EmptyState />
      ) : (
        <WaitlistTable list={list} />
      )}
    </Box>
  );
};

export default Waitlist;
